export default {
  background: function () {
    return {
      canvas: [
        {
          type: "rect",
          x: 0,
          y: 0,
          h: 595.28,
          w: 900.89,
          color: "#EDEDF2",
        },
      ],
    };
  },
  pageOrientation: "landscape",
  content: [
    {
      layout: "noBorders",
      table: {
        widths: [60, "auto", "*"],
        heights: [20, 20, 20],
        style: "profileSection",
        alignment: "center",
        body: [
          [
            // {

            //     stack:[{
            //     width: 60,
            //     height: 20,
            //     fillColor:"white",
            //     image:
            //       "",}
            {
              width: 60,
              height: 60,
              margin: [5, 5],
              fillColor: "white",
              rowSpan: 3,
              image: "",
            },

            // },
            {
              text: "Name: ",
              alignment: "left",
              style: "profiledata",
            },
            {
              text: "Rank: ",
              alignment: "left",
              style: "profiledata",
            },
          ],
          [
            {
              text: " ",
              style: "profiledata",
              alignment: "left",
            },

            {
              text: "Region: ",
              style: "profiledata",
              alignment: "left",
            },
            {
              text: "Lead Reviewer: ",
              style: "profiledata",
              alignment: "left",
            },
          ],
          [
            {
              text: " ",
              style: "profiledata",
              alignment: "left",
            },

            {
              text: "Office: ",
              style: "profiledata",
              alignment: "left",
            },
            {
              text: "Country: ",
              style: "profiledata",
              alignment: "left",
            },
          ],
        ],
      },
    },
    {
      //summarysection
      margin: [0, 10],
      // layout: "noBorders",
      layout: {
        hLineColor: function (i, node) {
          return "#e1e1e6";
        },
        vLineColor: function (i, node) {
          return i === 0 ? "#ffe600" : "#e1e1e6";
        },
        vLineWidth: function (i, node) {
          return i === 0 ? 3 : 1.5;
        },
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 1.5 : 1.5;
        },
      },
      table: {
        widths: ["*"],
        heights: [30],
        style: "summarySection",
        alignment: "center",
        body: [
          [
            {
              style: "summarySecRow",
              border: [true, true, true, false],
              fontSize: 14,
              color: "#40404d",
              text: "Summary",
            },
          ],
          [
            {
              text: " ",
              style: "summarySecRow",
              border: [true, false, true, false],
            },
          ],
          [
            {
              style: "summarySecRow",
              text: "Click on each pillar to view the list of selected impact actions and changes made to your baseline. Please refer to the dials for a representation of where you currently stand in comparison to your input from the planning activity.",
              border: [true, false, true, false],
            },
          ],
          /* PPMD SCORING HIDDEN */
         /*  [
            {
              width: 700,
              height: 85,
              margin: [5, 5],
              alignment: "center",
              fillColor: "white",
              border: [true, false, true, true],
              image: "",
            },
          ], */
        ],
      },
    },
  ],

  defaultStyle: {
    font: "Interstate",
  },
  header: {
    layout: "lightHorizontalLines",
    table: {
      widths: [30, "*"],
      style: "table",
      body: [
        [
          // normally you could put image directly here, but since you're
          // setting width to auto, we need an artificial wrapping-node
          // so that column-width does not interfere with image width

          {
            width: "30",
            heigh: "30",
            fillColor: "white",
            image:
              "data:image/png;base64,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",
          },

          {
            text: "LEAD 4D - FY22 Year - End  Report",
            style: "header",
            color: "#2e2e38",
            width: "*",
          },
        ],
      ],
    },
  },
  footer: {
    layout: "noBorders",
    table: {
      widths: ["auto", "*"],
      heights: [20, 20],
      style: "tablefooter",
      body: [
        [
          {
            text: "Powered by: LEAD 4D",
            style: "footer",
            width: "*",
          },
          {
            text: "LEAD 4D Report",
            style: "footer",
            width: "*",
            margin: [5, 4, 5, 4],
            alignment: "right",
          },
        ],
      ],
    },
  },
  styles: {
    table: {
      fillColor: "white",
      height: "30",
      width: "*",
    },
    tablefooter: {
      fillColor: "#FFE600",
      height: "20",
      width: "*",
      color: "#2e2e38",
    },
    header: {
      fontSize: 18,
      bold: true,
      color: "#2e2e38",
      margin: [5, 4, 0, 0],
      fillColor: "white",
    },
    footer: {
      fontSize: "8",
      margin: [5, 4, 0, 0],
      fillColor: "#FFE600",
      color: "#2e2e38",
    },
    profileSection: {
      fillColor: "white",
      fontSize: 15,
      width: "900",
      height: 40,
    },
    summarySection: {
      borderLeft: "yellow solid 2",
    },
    profiledata: {
      fontSize: 10,
      fillColor: "white",
      color: "#2e2e38",
      margin: [5, 5],
    },
    summarySecRow: {
      color: "#595967",
      alignment: "left",
      fontSize: 10,
      fillColor: "white",
      margin: [10, 5],
    },
    mainHeading: {
      color: "#40404d",
      alignment: "left",
      fontSize: 14,
      fillColor: "white",
      margin: [10, 5],
    },
    subHeading: {
      color: "#40404d",
      alignment: "left",
      fontSize: 11,
      fillColor: "white",
      margin: [10, 10],
    },
    statment: {
      color: "#595967",
      alignment: "left",
      fontSize: 9,
      fillColor: "#f9f9f9",
      margin: [10, 10],
    },
    baseLine: {
      color: "white",
      alignment: "center",
      fontSize: 9,
      width: 200,
      fillColor: "#f9f9f9",
      margin: [10, 10],
    },
    changed: {
      color: "white",
      alignment: "center",
      fontSize: 9,
      fillColor: "#f9f9f9",
      margin: [10, 10],
      width: 200,
    },
    page: {},
  },
};
